<template>
  <div>
    <div class="videoWrapper">
      <div id="email-panel" style="display: none">{{ userEmail }}</div>
      <video
        class="video-js vjs-default-skin"
        :id="customid"
        data-cy="ivPlayerVideo"
        width="480px"
        height="268px"
        preload="metadata"
        src="https://initialview.com/ivgcs/video/blank.mp4"
        type="video/mp4"
        playsinline
        webkit-playsinline="webkit-playsinline"
      />
    </div>
  </div>
</template>

<script>
/*jshint esversion: 6 */
"use strict";

import Vue from "vue";
import ivbus from "@/utils/ivbus.js";
import videojs from "video.js";
import playerjs from "player.js";
// import jQuery from 'jquery';
// window.jQuery = $;
// window.$ = $;

/*! videojs-markers - v0.5.0 - 2015-08-01
 * Copyright (c) 2015 ; Licensed  */
/*! videojs-markers !*/

// (function($, videojs, undefined) {
//default setting
var defaultSetting = {
  markerStyle: {
    width: "10px",
    "border-radius": "0%",
    "background-color": "#e96724",
  },
  markerTip: {
    display: true,
    text: function (marker) {
      return "Break: " + marker.text;
    },
    time: function (marker) {
      try {
        return marker.time;
      } catch (e) {
        //console.log('no marker time')
        return 0;
      }
    },
  },
  breakOverlay: {
    display: false,
    displayTime: 3,
    text: function (marker) {
      return "Break overlay: " + marker.overlayText;
    },
    style: {
      width: "100%",
      height: "20%",
      "background-color": "rgba(0,0,0,0.7)",
      color: "white",
      "font-size": "17px",
    },
  },
  onMarkerClick: function (marker) {},
  onMarkerReached: function (marker) {},
  markers: [],
};

// create a non-colliding random number
function generateUUID() {
  var d = new Date().getTime();
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  return uuid;
}

function registerVideoJsMarkersPlugin(options) {
  /**
   * register the markers plugin (dependent on jquery)
   */

  var setting = $.extend(true, {}, defaultSetting, options),
    markersMap = {},
    markersList = [], // list of markers sorted by time
    videoWrapper = $(this.el()),
    currentMarkerIndex = -1,
    player = this,
    markerTip = null,
    breakOverlay = null,
    overlayIndex = -1;

  function sortMarkersList() {
    // sort the list by time in asc order
    markersList.sort(function (a, b) {
      return setting.markerTip.time(a) - setting.markerTip.time(b);
    });
  }

  function addMarkers(newMarkers) {
    // create the markers
    $.each(newMarkers, function (index, marker) {
      marker.key = generateUUID();

      videoWrapper
        .find(".vjs-progress-control")
        .append(createMarkerDiv(marker));

      // store marker in an internal hash map
      markersMap[marker.key] = marker;
      markersList.push(marker);
    });

    sortMarkersList();
  }

  function getPosition(marker) {
    return (setting.markerTip.time(marker) / player.duration()) * 100;
  }

  function createMarkerDiv(marker, duration) {
    var markerDiv = $(
      "<div class='vjs-marker'><span>" + marker.index + "</span></div>"
    );
    markerDiv
      .css(setting.markerStyle)
      .css({
        "margin-left": -parseFloat(markerDiv.css("width")) / 2 + "px",
        left: getPosition(marker) + "%",
      })
      .attr("data-marker-key", marker.key)
      .attr("data-marker-time", setting.markerTip.time(marker));

    // add user-defined class to marker
    if (marker.class) {
      markerDiv.addClass(marker.class);
    }

    // bind click event to seek to marker time
    markerDiv.on("click", function (e) {
      var preventDefault = false;
      if (typeof setting.onMarkerClick === "function") {
        // if return false, prevent default behavior
        preventDefault = setting.onMarkerClick(marker) == false;
      }

      if (!preventDefault) {
        var key = $(this).data("marker-key");
        player.currentTime(setting.markerTip.time(markersMap[key]));
      }
    });

    if (setting.markerTip.display) {
      registerMarkerTipHandler(markerDiv);
    }

    return markerDiv;
  }
  function updateMarkers() {
    // update UI for markers whose time changed

    for (var i = 0; i < markersList.length; i++) {
      var marker = markersList[i];
      var markerDiv = videoWrapper.find(
        ".vjs-marker[data-marker-key='" + marker.key + "']"
      );
      var markerTime = setting.markerTip.time(marker);

      if (markerDiv.data("marker-time") != markerTime) {
        markerDiv
          .css({ left: getPosition(marker) + "%" })
          .attr("data-marker-time", markerTime);
      }
    }
    sortMarkersList();
  }

  function removeMarkers(indexArray) {
    // reset overlay
    if (breakOverlay) {
      overlayIndex = -1;
      breakOverlay.css("visibility", "hidden");
    }
    currentMarkerIndex = -1;

    for (var i = 0; i < indexArray.length; i++) {
      var index = indexArray[i];
      var marker = markersList[index];
      if (marker) {
        // delete from memory
        delete markersMap[marker.key];
        markersList[index] = null;

        // delete from dom
        videoWrapper
          .find(".vjs-marker[data-marker-key='" + marker.key + "']")
          .remove();
      }
    }

    // clean up array
    for (var i = markersList.length - 1; i >= 0; i--) {
      if (markersList[i] === null) {
        markersList.splice(i, 1);
      }
    }

    // sort again
    sortMarkersList();
  }

  // attach hover event handler
  function registerMarkerTipHandler(markerDiv) {
    markerDiv
      .on("mouseover", function () {
        var marker = markersMap[$(this).data("marker-key")];

        markerTip.find(".vjs-tip-inner").text(setting.markerTip.text(marker));

        // margin-left needs to minus the padding length to align correctly with the marker
        markerTip.css({
          left: getPosition(marker) + "%",
          "margin-left": -parseFloat(markerTip.css("width")) / 2 - 5 + "px",
          visibility: "visible",
        });
      })
      .on("mouseout", function () {
        markerTip.css("visibility", "hidden");
      });
  }

  function initializeMarkerTip() {
    markerTip = $(
      "<div class='vjs-tip'><div class='vjs-tip-arrow'></div><div class='vjs-tip-inner'></div></div>"
    );
    videoWrapper.find(".vjs-progress-control").append(markerTip);
  }

  // show or hide break overlays
  function updateBreakOverlay(currentTime) {
    if (currentMarkerIndex < 0) {
      return;
    }

    var marker = markersList[currentMarkerIndex];
    var markerTime = setting.markerTip.time(marker);

    if (
      currentTime >= markerTime &&
      currentTime <= markerTime + setting.breakOverlay.displayTime
    ) {
      if (overlayIndex != currentMarkerIndex) {
        overlayIndex = currentMarkerIndex;
        breakOverlay
          .find(".vjs-break-overlay-text")
          .text(setting.breakOverlay.text(marker));
      }

      breakOverlay.css("visibility", "visible");
    } else {
      overlayIndex = -1;
      breakOverlay.css("visibility", "hidden");
    }
  }

  // problem when the next marker is within the overlay display time from the previous marker
  function initializeOverlay() {
    breakOverlay = $(
      "<div class='vjs-break-overlay'><div class='vjs-break-overlay-text'></div></div>"
    ).css(setting.breakOverlay.style);
    videoWrapper.append(breakOverlay);
    overlayIndex = -1;
  }

  function onTimeUpdate() {
    /*
             check marker reached in between markers
             the logic here is that it triggers a new marker reached event only if the player 
             enters a new marker range (e.g. from marker 1 to marker 2). Thus, if player is on marker 1 and user clicked on marker 1 again, no new reached event is triggered)
         */

    var getNextMarkerTime = function (index) {
      if (index < markersList.length - 1) {
        return setting.markerTip.time(markersList[index + 1]);
      }
      // next marker time of last marker would be end of video time
      return player.duration();
    };
    var currentTime = player.currentTime();
    var newMarkerIndex;

    if (currentMarkerIndex != -1) {
      // check if staying at same marker
      var nextMarkerTime = getNextMarkerTime(currentMarkerIndex);
      if (
        currentTime >=
          setting.markerTip.time(markersList[currentMarkerIndex]) &&
        currentTime < nextMarkerTime
      ) {
        return;
      }
    }

    // check first marker, no marker is selected
    if (
      markersList.length > 0 &&
      currentTime < setting.markerTip.time(markersList[0])
    ) {
      newMarkerIndex = -1;
    } else {
      // look for new index
      for (var i = 0; i < markersList.length; i++) {
        nextMarkerTime = getNextMarkerTime(i);

        if (
          currentTime >= setting.markerTip.time(markersList[i]) &&
          currentTime < nextMarkerTime
        ) {
          newMarkerIndex = i;
          break;
        }
      }
    }

    // set new marker index
    if (newMarkerIndex != currentMarkerIndex) {
      // trigger event
      if (newMarkerIndex != -1 && options.onMarkerReached) {
        options.onMarkerReached(markersList[newMarkerIndex]);
      }
      currentMarkerIndex = newMarkerIndex;
    }

    // update overlay
    if (setting.breakOverlay.display) {
      updateBreakOverlay(currentTime);
    }
  }

  // setup the whole thing
  function initialize() {
    if (setting.markerTip.display) {
      initializeMarkerTip();
    }

    // remove existing markers if already initialized
    player.markers.removeAll();
    addMarkers(options.markers);

    if (setting.breakOverlay.display) {
      initializeOverlay();
    }
    onTimeUpdate();
    player.on("timeupdate", onTimeUpdate);
  }

  // setup the plugin after we loaded video's meta data
  player.on("loadedmetadata", function () {
    initialize();
  });

  // exposed plugin API
  player.markers = {
    getMarkers: function () {
      return markersList;
    },
    next: function () {
      // go to the next marker from current timestamp
      var currentTime = player.currentTime();
      for (var i = 0; i < markersList.length; i++) {
        var markerTime = setting.markerTip.time(markersList[i]);
        if (markerTime > currentTime) {
          player.currentTime(markerTime);
          break;
        }
      }
    },
    prev: function () {
      // go to previous marker
      var currentTime = player.currentTime();
      for (var i = markersList.length - 1; i >= 0; i--) {
        var markerTime = setting.markerTip.time(markersList[i]);
        // add a threshold
        if (markerTime + 0.5 < currentTime) {
          player.currentTime(markerTime);
          break;
        }
      }
    },
    add: function (newMarkers) {
      // add new markers given an array of index
      addMarkers(newMarkers);
    },
    remove: function (indexArray) {
      // remove markers given an array of index
      removeMarkers(indexArray);
    },
    removeAll: function () {
      var indexArray = [];
      for (var i = 0; i < markersList.length; i++) {
        indexArray.push(i);
      }
      removeMarkers(indexArray);
    },
    updateTime: function () {
      // notify the plugin to update the UI for changes in marker times
      updateMarkers();
    },
    reset: function (newMarkers) {
      // remove all the existing markers and add new ones
      player.markers.removeAll();
      addMarkers(newMarkers);
    },
    destroy: function () {
      // unregister the plugins and clean up even handlers
      player.markers.removeAll();
      breakOverlay.remove();
      markerTip.remove();
      player.off("timeupdate", updateBreakOverlay);
      delete player.markers;
    },
  };
}

videojs.plugin("markers", registerVideoJsMarkersPlugin);

// })(jQuery, videojs);

//our custom template
export default {
  props: {
    embedded: {
      type: Boolean,
      default: false,
    },
    staticsrc: {
      type: String,
      default: "",
    },
    customid: {
      type: String,
      default: "main_video",
    },
    eventns: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      myPlayer: {},
      videometa: {},
      currentVideoQuestionId: 0,
      userEmail: "",
      readyToPlay: false,
      retrying: false,
    };
  },
  created: function () {
    var that = this;
    console.log("iv-player component created hook");
    ivbus.$on("iv-player-timetravel" + this.eventns, this.timetravel);
    ivbus.$on("iv-player-questions-updated", function (questions) {
      console.log("inside iv-player-questions-updated");
      console.log(questions);
      if (that.myPlayer.markers) {
        that.myPlayer.markers.removeAll();
        that.myPlayer.markers.add(questions);
        if (!that.embedded) {
          $(".vjs-tip").hide();
        }
      }
    });
    ivbus.$on("meta-ready" + this.eventns, this.setVideoData);
    ivbus.getFlag("iv-player-change-email").then(function (result) {
      that.setUserEmail(result);
    });
    console.log("iv-player component, created hook, getFlag called");
  },
  mounted: function () {
    var that = this;
    console.log("iv-player component mounted hook");
    //check if player already has a staticsrc url
    if (that.staticsrc == "") {
      ivbus.$emit("iv-player-mounted" + this.eventns, true);
    } else {
      var videometa = {
        status: 200,
        star: false,
        recruited: false,
        ivVideo: that.staticsrc,
        ivVideoData: { questions: [] },
        user: "",
        org: "",
        message: "Loading...",
        date: "",
      };
      that.setVideoData(videometa);
    }
  },
  methods: {
    setVideoData: function (data) {
      console.log(data);
      if (data.status == 200) {
        this.videometa = data;
        this.setupVideo();
        return;
      } else {
        this.displayNotFound();
        return;
      }
    },

    setupVideo: function () {
      console.log("setupVideo called");

      var p = this;

      if (p.myPlayer.id_) {
        // is this a good proxy for initialization having started?
        return;
      }
      // element.setAttribute("id", p.customid);

      if (
        p.customid == "otis" &&
        p.videometa.ivType != "otis" &&
        p.videometa.ivType != "epic"
      ) {
        return;
      }
      if (
        p.customid != "otis" &&
        (p.videometa.ivType == "otis" || p.videometa.ivType == "epic")
      ) {
        return;
      }

      p.myPlayer = videojs(
        p.customid,
        {
          controls: true,
          autoplay: false,
          aspectRatio: "480:268",
          playbackRates: [1, 1.25, 1.5, 1.75, 2],
          controlBar: {
            volumePanel: {
              inline: false,
            },
            pictureInPictureToggle: false,
          },
        },
        function () {
          if (p.videometa.block_video) {
            var mask = document.createElement("div");
            mask.id = "block-panel";
            $(".video-js video").after(mask);
          }
          var adapter = new playerjs.VideoJSAdapter(this);
          adapter.ready();
        }
      );

      videojs.addLanguage("en", {
        "The media could not be loaded, either because the server or network failed or because the format is not supported.":
          "Please refresh page to try loading the video again. If the problem persists, please send a screenshot of this page to us at contact@initialview.com!",
      });

      p.myPlayer.ready(function () {
        var source = "";

        p.myPlayer.src(
          (source = { src: p.videometa.ivVideo, type: "video/mp4" })
        );

        //setup marker data structure
        p.myPlayer.markers({
          markerTip: {
            display: true,
            text: function (marker) {
              return marker.text;
            },
          },
          markers: [{ index: 0, time: 7, text: "..." }],
          onMarkerReached: function (marker) {
            try {
              console.log(marker);
              p.currentVideoQuestionId = marker.index;
              p.emitCurrentVideoQuestionId();
            } catch (e) {
              console.log("index terror: " + e);
            }
          },
        });

        p.myPlayer.load();

        p.myPlayer.on("play", function () {
          $("#" + p.customid + " .vjs-big-play-button").css("display", "none");
        });

        p.myPlayer.on("pause", function () {
          $("#" + p.customid + " .vjs-big-play-button").css("display", "block");
        });

        p.myPlayer.on("loadedmetadata", function () {
          p.myPlayer.markers.removeAll();
          p.myPlayer.markers.add(p.videometa.ivVideoData.questions);
          if (!p.embedded) {
            $(".vjs-tip").hide();
          }

          //auth if needed??
          // if (p.$get("authorizing")) {
          //     p.$set("loaded", true);
          // } else {
          //     p.displayVideo();
          // }
        });

        p.myPlayer.on("error", function (e) {
          console.log(e);

          if (p.myPlayer.networkState() == 3) {
            //network state: NETWORK_NO_SOURCE
            if (p.videometa.ivVideo == p.videometa.ivVideoAlt) {
              p.displayNotFound();
            } else {
              if (p.retrying) {
                p.displayNotFound();
                return;
              }
              p.retrying = true;
              console.log("attempting to play alt url for video");
              p.myPlayer.src(
                (source = { src: p.videometa.ivVideoAlt, type: "video/mp4" })
              );
              p.myPlayer.load();
            }
          }
        });

        // set up video speed controls
        document.addEventListener('keydown', function(event) {
          if (event.shiftKey) {
            var currentRate = p.myPlayer.playbackRate();
            var newRate = currentRate
            if (event.key == ".") {
              newRate = Math.min(currentRate + 0.25, 2)
              console.log(newRate)
            }
            if (event.key == ",") {
              newRate = Math.max(currentRate - 0.25, 1)
              console.log(newRate)
            }
            p.myPlayer.playbackRate(newRate);
          }
        });

        p.myPlayer.on('ratechange', function() {
          var newRate = p.myPlayer.playbackRate();
          localStorage.setItem("playbackSpeed", newRate);
          console.log('Playback rate changed to: ' + newRate);
        });

        setTimeout(function() {
          var savedRate = localStorage.getItem('playbackSpeed');
          if (savedRate) {
            p.myPlayer.playbackRate(parseFloat(savedRate));
            console.log("Set playback rate to " + p.myPlayer.playbackRate());
          }
        }, 10);

        var domain = window.location.origin;

        $(
          '<button id="back-10s-btn-' + p.customid + '" class="back-10s-btn vjs-control vjs-button" type="button" aria-live="polite" title="Rewind 10 Seconds"><span class="vjs-control-text">Rewind 10 Seconds</span><img class="back-ten-seconds" src="data:image/png;base64,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"</button>'
        ).insertAfter("#" + p.customid + " .vjs-control-bar .vjs-play-control");
        $("#" + p.customid + " .vjs-control-bar .back-ten-seconds").click(
          function () {
            var c = p.myPlayer.currentTime();
            p.myPlayer.currentTime(c - 10);
            p.myPlayer.play();
          }
        );

        $(
          '<button id="skip-10s-btn-' + p.customid + '" class="skip-10s-btn vjs-control vjs-button" type="button" aria-live="polite" title="Skip 10 Seconds"><span class="vjs-control-text">Skip 10 Seconds</span><img class="skip-ten-seconds" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IB2cksfwAAAARnQU1BAACxjwv8YQUAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAAd0SU1FB+oJBAAWFP87BsgAAAQZSURBVDjLdZTfa1xFFMe/Z7K/kv2RWGmyNdtYSxQpKEgpfWgLIlUwRWuRFaEUC7ZYKQX/hRbqm4K0xRfBp4IYihaxSBWsELGlBnwKhkazbOfO3Jvd7DW9mzT7487XB3fDWvS8zTkzn5lzvnMO8IjNzs4OkRwa9Hme95a5b14PvOAl3/f39ffhP0wGFySHRCQGAK31ZFKSLzi4JxzcKSVqJ4ivSY46uE9KpdIdkkpE3CAj0QPJhQsXRETiIAieiuP4fZLHJCHThWwBaw/WkMvn0Iyah0TJd+Lkktb6uIjc62XDPlhICgCICI0xbwvl4thjY7vXHqwhjuO7IvIjgIMAdonIdedcieSXk5OTX0AQC4T/ypikAgBjzFlrLaMoojHmptZ6ZnFxMd+LHbZVe9AYc9j3/RcB4DzOKwCoVCqZarW6l2R6C+trf8YYs9lYbdB69qN+sCdQZrDGALCwsJACgFnODhljLhljQmPMUQDA8vLyhPXs7YcbD2mM+WxQ7UFQP5OeKQCYn59PGmOuttttep53u1KpFKG1Ph2GIY0x97TW04OKBUGwv9Fo7NzKxPf3BUHw7qpenez7Vqoru40xi2EYUmt9WimoI8lEEgCulUqlJQAIw3A0CIKPReQb13EHAGBlZeU4gMsg3ugkOleDIHgOAManxv8E8FUykYRS6oiCYE/UjGLn3N3+rZ1OZx8cJkj+RTKztLSUJvmBUmp2ojjxGoANEXlvS1qRO1EUxQD2KAiKIKKEJBr9umzfvv2n8eL4OyR1l91UoVAogRgG8FuP8atz7klr7QgAxHEcEoxAlJRA1iFIUjEFAKOjo0pEOiLSFREqqqjdbocEtxQXkVEArbm5uRYAKKWSSlRCRCJFcjmTzmQZ82kAmJ6ebtVqtVytVvvnMys5lM1mYwC/gDjj+34ZxCskb26pF+OZVDqVA7CkQMyl02mIyKu1Wi0HAN1ud1scx8cA3CU5trm5+byInHN0f4jIKYJXisXi5+VyOa7X63kqzmTSGRD8GVrr/caYRhAE9DzvBABYa0fq9XqeZFJrPay1Hu4/pl6v5wHg1q1bid4kOuH7Po0xDa31fvQAF9fX12k8c79arR4c7AqSQlIWFhZSJBP93u+15AHjmfsb6xu01n64VYJKpTJmPfttq9WitdZ4nneyUqlk8D+mtR72PO+k9axptVr0PO9GGIZj/WkzJCKx1npSQV3JFXJHO+0OWq3WDwSvOefmATR6rG1Kqb0CeTOdTh9OppJoNpvXnXNnS6WSR3JI+n1bLpdja+0IHM5AcC5fyO+iI5rN5gaA1R7w8WwuO6KUQhRFFefcZaXUpzt27NjoD1sZHAblcjkGgGq1ujuhEjNQeBnAswIpAQBBDeB3OHzfdd0bU1NTfz569m+UFI7JfAvCHQAAAABJRU5ErkJggg=="</button>'
        ).insertAfter("#" + p.customid + " .vjs-control-bar #back-10s-btn-" + p.customid);
        $("#" + p.customid + " .vjs-control-bar .skip-ten-seconds").click(
          function () {
            var c = p.myPlayer.currentTime();
            p.myPlayer.currentTime(c + 10);
            p.myPlayer.play();
          }
        );

        $(
          "#" + p.customid + " .vjs-control-bar .vjs-volume-panel"
        ).insertBefore(
          "#" + p.customid + " .vjs-control-bar .vjs-fullscreen-control"
        );

        if (p.embedded) {
          var link = window.location.href.replace(/\/embed/, "");
          $(
            '<a target="_blank" id="open-iv-btn" href="' +
              link +
              '" title="Open in InitialView" class="vjs-control vjs-button" type="button" aria-live="polite"><span class="vjs-control-text">Open in InitialView</span><img class="iv-icon" src="' +
              domain +
              '/s/img/_shared/favicon.png"</button>'
          ).insertBefore(
            "#" + p.customid + " .vjs-control-bar .vjs-fullscreen-control"
          );
        }

        $(
          "#" + p.customid + " .vjs-control-bar .vjs-fullscreen-control"
        ).remove();

        $(".video-js").on("touchstart", function () {
          if (p.myPlayer.paused()) {
            p.myPlayer.play();
          } else {
            p.myPlayer.pause();
          }
        });

        p.readyToPlay = true;
        ivbus.$emit("iv-player-ready-to-play" + this.eventns, true);
      });
    },

    setUserEmail: function (email) {
      var that = this;
      var waitForPlayer = function () {
        console.log("updating email:" + email);
        that.userEmail = email;
        if (email.length > 0) {
          console.log("updating email panel");
          window.setTimeout(function () {
            $("#email-panel").bigText({
              rotateText: -30,
              fontSizeFactor: 0.5,
            });
          });
        } else {
          $("#email-panel").css("display", "none");
        }
      };
      if (that.readyToPlay) {
        waitForPlayer();
      } else {
        ivbus.$on("iv-player-ready-to-play" + this.eventns, waitForPlayer);
      }
    },

    emitCurrentVideoQuestionId: function () {
      console.log("emit question id:" + this.currentVideoQuestionId);
      ivbus.$emit(
        "iv-player-current-question" + this.eventns,
        this.currentVideoQuestionId
      );
    },

    timetravel: function (targetTime) {
      if (
        this.customid == "otis" &&
        this.videometa.ivType != "otis" &&
        this.videometa.ivType != "epic"
      ) {
        return;
      }
      if (
        this.customid != "otis" &&
        (this.videometa.ivType == "otis" || this.videometa.ivType == "epic")
      ) {
        return;
      }
      this.myPlayer.currentTime(targetTime);
      this.myPlayer.play();
    },

    backTenSeconds: function () {
      //console.log('back ten seconds');
      if (
        this.customid == "otis" &&
        this.videometa.ivType != "otis" &&
        this.videometa.ivType != "epic"
      ) {
        return;
      }
      if (
        this.customid != "otis" &&
        (this.videometa.ivType == "otis" || this.videometa.ivType == "epic")
      ) {
        return;
      }
      var c = this.myPlayer.currentTime();
      this.myPlayer.currentTime(c - 10);
      this.myPlayer.play();
    },

    displayVideo: function () {
      var that = this;
      $("#background-before-video").css("display", "none");
      $("#" + that.customid).css("display", "block");
      $("#" + that.customid + " video").css("display", "block");
      setTimeout(function () {
        $(".waitToLoad").removeClass("hide");
      }, 60);
    },

    displayNotFound: function () {
      this.notFound = true;
      if (!this.authorizing) {
        $("#loading-wrapper .loader").css("display", "none");
        $("#loading-wrapper .linkedin-btn").css("display", "none");
        $("#loading-wrapper .video-not-found").css("display", "block");
      }
    },

    getParameterByName: function (name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
  }, //END of methods for Component iv-player
};
</script>

<style lang="scss">
.video-js {
  font-size: 10px;
  color: #fff;
  width: 100% !important;
  height: 100%;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.vjs-default-skin .vjs-big-play-button {
  /* video poster image */
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAC8UlEQVR42u2cMWgUQRSGU1hYWFgYCOrMbrCxFGysRBBsrMTS4mYmIUgsrARLrVKIlYKFha1gJZYWWoiCjUQQMSiBJBgTo8nubHIxkpxvzksuhf08ue+Dx179Pv6bndm3OzQEAAAAAAAAAAAAAAAAAAAAAP+mnjh6hC5oEuLsSgzFZTqhRYi3nTqYGJ19vOrKw3REgxCp6G07paVp2fN0RYGQvXJ2Q+Q8XJ4cPkR3NAhJaXG2LVKWKleeoUMKhOyrdgzmfseVB+mUDiGpNitvvzSuPEW3dAjZS4usL1OdW0MH6JoOIX/vxLz9WLvyJJ1TIGR/WtacvUn39Ajpri21N+9lM1nSRR1C9tJSjRWTdFKPkFS/pF5vjB87Tkd1COmW3B6vV6G4QleVCOnVVu2Llxzr6xGyW1Udikt0WI+QtG+RtNinHFQqEdKrbam1pjV6gW7rELJbv9NDMA4q9QhJtSP1I7ZGz9J5HUI6vUfGKS0POKjUIqSflsX1cXsaCzqE9PctobhLWvQIkTI7MZj5tQlzAiEqhPTvxJpQTiFEUwWzXXk70746UiJEWVrqQXwIplhIWlu2ZcGfbiaHRxCi5y/suyRlYWBOjxXLmJe15J2k5M1ADVXoTIV9leaMK2evD9z+RJmMxe6YkTcvBnZ4QpGMt713Va6xD8lY0RffUipkvXjOSFFmIdHJoi2pkN8tDrHyCllJA9xyfcboUGYh0dsP6SEVqcgupFiV64LUk8aVI3Q+p5BgPsl1ibd9swvpp4LBufxCZqM3c6Qiv5DYOxB8xHvv+YXMioiv1Vhxkc5mFFJ5Qyq0CJHd9lwaUIiuPEc38wppy257VRbuewxT5xbi7GIMllTkFtJ7LbqqvblDKrILMcty/cz3T3ILCcXWbip4lSC3kNA9lZ0hFfmFbMnC3ciacZsh6NxCnP2ZHqny9Z/sQgpSoUVIlT6CGcw0X/nRIWRT7qRukAotQkgFAAAAAAAAAAAAAAAAAAAAwP/NH0w6zE+Gk/OsAAAAAElFTkSuQmCC") !important;
  border: none !important;
  border-radius: 0 !important;
  width: 100% !important;
  height: 100% !important;
  top: 0 !important;
  left: 0 !important;
  background-repeat: no-repeat !important;
  background-position: center center !important;
  background-color: rgba(0, 0, 0, 0.64);
}

.vjs-big-play-button span.vjs-icon-placeholder {
  visibility: hidden !important;
}

.vjs-default-skin .vjs-big-play-button:hover {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.1);
}

.vjs-default-skin .vjs-big-play-button:focus {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.1);
}

.vjs-default-skin .vjs-big-play-button:before {
  content: none !important;
}
/* The default color of control backgrounds is mostly black but with a little
   bit of blue so it can still be seen on all-black video frames, which are common. */
.video-js .vjs-control-bar,
.video-js .vjs-big-play-button,
.video-js .vjs-menu-button .vjs-menu-content {
  /* IE8 - has no alpha support */
  background-color: #000;
  /* Opacity: 1.0 = 100%, 0.0 = 0% */
  background-color: rgba(0, 0, 0, 0.38);
}

.video-js .vjs-slider {
  background-color: lighten(#333, 33%);
  background-color: rgba(lighten(#333, 33%), 0.5);
}

.video-js .vjs-volume-level,
.video-js .vjs-play-progress,
.video-js .vjs-slider-bar {
  background: #fff;
}

.video-js .vjs-load-progress {
  background: lighten(lighten(#333, 33%), 25%);
  background: rgba(lighten(#333, 33%), 0.5);
}

.video-js .vjs-load-progress div {
  background: lighten(lighten(#333, 33%), 50%);
  background: rgba(lighten(#333, 33%), 0.75);
}

.back-10s-btn, .skip-10s-btn {
  cursor: pointer;
  margin-right: 10px;
}

.back-10s-btn .back-ten-seconds, .skip-10s-btn .skip-ten-seconds {
  width: 20px;
  height: 20px;
}

#open-iv-btn {
  cursor: pointer;
  margin-right: 10px;
}

#open-iv-btn .iv-icon {
  width: 30px;
  height: 30px;
}

#background-before-video {
  width: 100%;
  height: 100%;
  background-color: #333;
  position: relative;
}

#background-before-video #loading-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

#background-before-video .loader {
  margin-bottom: 20px;
}

#background-before-video .video-not-found {
  font-family: "Lato";
  color: rgba(241, 90, 36, 0.7);
}

#background-before-video .linkedin-btn {
  margin-bottom: 10px;
}

.videoWrapper {
  overflow: hidden;
}

#email-panel {
  color: rgba(255, 255, 255, 0.1);
  position: absolute;
  z-index: 1000;
  font-family: "Lato";
  font-size: 14px;
  pointer-events: none;
}

#block-panel {
  position: absolute;
  background-color: #333;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.vjs-mouse-display {
  font-family: "Lato";
}

.video-js .vjs-mouse-display:after,
.video-js .vjs-play-progress:after {
  top: -3.2em;
  font-family: "Lato";
}

.video-js .vjs-control-bar {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

@media (max-width: 992px) {
  .video-js .vjs-control-bar {
    display: none;
  }
}

/* markers */

.vjs-marker span {
  font-size: 14px;
}

.vjs-marker {
  z-index: 1000 !important;
  font-family: "Lato";
}

.vjs-tip {
  bottom: 55px !important;
  z-index: 2000000 !important;
  /*max-width: 100% !important;*/
}

.vjs-tip .vjs-tip-inner {
  font-size: 16px;
  font-family: "Lato";
  /*max-width: 100% !important;*/
}

/*  @media screen and (min-width: 640px) {
    .vjs-marker {
        width: 20px !important;
    }

    #main_video {
        width: 640px !important;
        height: 400px !important;
    }
} */

.vjs-marker {
  color: white;
  border-color: black;
  top: 0px;
  padding: 7px 0px 0px 0px;
  position: absolute;
  left: 0;
  bottom: 0em;
  opacity: 1;
  height: 100%;
  transition: opacity 0.2s ease;
  -webkit-transition: opacity 0.2s ease;
  -moz-transition: opacity 0.2s ease;
}

.vjs-tip {
  visibility: hidden;
  display: block;
  opacity: 0.8;
  padding: 5px;
  font-size: 10px;
  position: absolute;
  bottom: 14px;
  z-index: 100000;
}
.vjs-tip .vjs-tip-arrow {
  background: url(data:image/gif;base64,R0lGODlhCQAJAIABAAAAAAAAACH5BAEAAAEALAAAAAAJAAkAAAIRjAOnwIrcDJxvwkplPtchVQAAOw==)
    no-repeat top left;
  bottom: 0;
  left: 50%;
  margin-left: -4px;
  background-position: bottom left;
  position: absolute;
  width: 9px;
  height: 5px;
}
.vjs-tip .vjs-tip-inner {
  border-radius: 3px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  padding: 5px 8px 4px 8px;
  background-color: black;
  color: white;
  max-width: 200px;
  text-align: center;
}
.vjs-break-overlay {
  visibility: hidden;
  position: absolute;
  z-index: 100000;
  top: 0;
}
.vjs-break-overlay .vjs-break-overlay-text {
  padding: 9px;
  text-align: center;
}

/* spinner */

.video-js .vjs-loading-spinner {
  border-top-color: #79a9ad;
}

.video-js .vjs-loading-spinner:before,
.video-js .vjs-loading-spinner:after {
  border-top-color: #79a9ad;
}

.video-js .vjs-seeking .vjs-loading-spinner:before,
.video-js .vjs-waiting .vjs-loading-spinner:before {
  border-top-color: #79a9ad;
}

.video-js .vjs-seeking .vjs-loading-spinner:after,
.video-js .vjs-waiting .vjs-loading-spinner:after {
  border-top-color: #79a9ad;
}
@keyframes vjs-spinner-fade {
  0% {
    border-top-color: #79a9ad;
  }
  20% {
    border-top-color: #79a9ad;
  }
  35% {
    border-top-color: #e96724;
  }
  60% {
    border-top-color: #79a9ad;
  }
  100% {
    border-top-color: #79a9ad;
  }
}

@-webkit-keyframes vjs-spinner-fade {
  0% {
    border-top-color: #79a9ad;
  }
  20% {
    border-top-color: #79a9ad;
  }
  35% {
    border-top-color: #e96724;
  }
  60% {
    border-top-color: #79a9ad;
  }
  100% {
    border-top-color: #79a9ad;
  }
}

/* player.css */
#viewfinder {
  width: 100%;
  transform: scale(-1, 1);
  border: 3px #e96724 dashed;
}

#player {
  background-color: #fff;
}

/*#interviewee_name {
	margin-top:0px;
	padding-left:20px;
	padding-bottom:0px;
	color: #333;
	font-size: 28px;
	text-align: left;
}
*/

/*#student-info-area {
	margin-bottom:40px;
}
*/

.tab-area-row {
  background-color: #e4e5e5;
  padding-top: 16px;
  margin-top: 0;
  border: solid 2px #ccc;
  box-shadow: 0 0 15px #ccc;
  border-radius: 0 10px 10px 10px;
  padding: 10px;
  /*margin-top: -5px;*/
}

.tab-area-row-pdf {
  height: 850px;
}

.tab-area-row-pdf div {
  height: 790px;
}

.headshot {
  min-width: 52px;
  width: 52px;
  height: 52px;
}

.tab-header.tab-header-active {
  box-shadow: 0 15px 0 -2px #e4e5e5, 0 0 15px #ccc;
  border: solid 2px #ccc;
  border-bottom: 0;
}

.tab-header {
  border-radius: 10px 10px 0 0;
  padding: 10px;
  text-align: center;
  border: solid 1px #ccc;
  border-bottom: 0;
}

@media (max-width: 768px) {
  .col-xs-12 {
    padding-left: 0;
    padding-right: 0;
  }

  .question {
    margin-left: 5px;
    width: 100%;
  }

  #questions {
    margin-left: 0;
    margin-right: 0;
  }
}

@media (max-width: 992px) {
  #interview_questions_wrapper {
    margin-top: 10px;
  }
}

/* ELEVEATOR PITCH STYLING */
.ep-recording-header {
  height: 200px;
  margin-top: 15px;
  max-width: 1200px;
  background-color: #e96724;
  border-radius: 15px;
  color: white;
  padding: 25px;
}

.ep-recording-body {
  width: 90%;
  margin-left: 5%;
  margin-top: -6%;
  margin-bottom: 150px;
  background-color: white;
  padding: 5%;
  border: solid 2px #e96724;
}

.ep-compare {
  font-size: 200%;
  text-align: center;
  display: block;
}

.check {
  color: #e96724;
}

.x {
  color: grey;
}

.orange-font {
  color: #e96724;
}
</style>